module.exports = __webpack_public_path__ + "img/45600.6fa991f4.jpg";